module.exports = __webpack_public_path__ + "media/src/images/icons/times/blue-1ed3d64639b4d6e6a1c18bed6cf2ec30.svg";